module.exports = __webpack_public_path__ + "static/logo-no-bcc16a56835d3b3cfdf6fb8bc6f2c675.png";